<template>
  <div>
    <input type="text"
      ref="input"
      placeholder="Enter letters to find extensions..."
      :value="word"
      @input="oninput"
    />
    <a class="clear"
      @click="clear"
    >&times;</a>
  </div>
</template>

<script>
export default {
  name: 'WordEntryInput',
  computed: {
    word() {
      return this.$store.state.word;
    },
  },
  methods: {
    oninput(e) {
      const word = e.target.value;
      return this.$store.dispatch('findExtensionWords', word);
    },
    clear() {
      this.$store.dispatch('findExtensionWords', '');
      this.$refs.input.select();
    },
  },
  mounted() {
    this.$refs.input.select();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  div {
    width: 100%;
    background: #eee;
    padding: 4px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }

  input {
    border: none;
    border-radius: 0;
    background: transparent;
    -webkit-appearance: none;
    font-size: 20px;
    flex-grow: 1;
  }

  a.clear {
    font-size: 24px;
    padding: 0 4px 0 8px;
    cursor: pointer;
  }

  a.clear:hover {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/WordEntryInput.vue